import { watch } from '@vue/composition-api'
import router from '@/router'

/**
 * Sincroniza refs de filtros/paginación con los query params de la URL.
 *
 * Acepta un objeto { key: ref } o { key: { ref, type } }.
 *   - type: 'number' fuerza la restauración como número (necesario para filtros
 *     cuyo valor es un id numérico que arrancan en null, p.ej. :reduce => val.id).
 *   - Si no se indica type, se infiere: si el ref arranca como número (page, per_page)
 *     se restaura como número; en caso contrario, como string.
 */
export default function useQuerySync(filters) {
  // Normalizar a { key: { ref, type } }
  const norm = {}
  Object.entries(filters).forEach(([key, val]) => {
    norm[key] = val && val.ref ? { ref: val.ref, type: val.type || null } : { ref: val, type: null }
  })

  // inicializar desde URL
  const initFromQuery = () => {
    const query = router.currentRoute.query

    Object.entries(norm).forEach(([key, { ref, type }]) => {
      if (query[key] !== undefined) {
        const asNumber = type === 'number' || (type === null && typeof ref.value === 'number')
        ref.value = asNumber ? Number(query[key]) : query[key]
      }
    })
  }

  initFromQuery()

  // actualizar URL al cambiar filtros
  Object.entries(norm).forEach(([key, { ref }]) => {
    watch(ref, val => {
      const newQuery = { ...router.currentRoute.query }

      if (val === null || val === '' || val === undefined) {
        delete newQuery[key]
      } else {
        newQuery[key] = val
      }

      router.replace({ query: newQuery })
    })
  })
}
